import { render, staticRenderFns } from "./Taxis.vue?vue&type=template&id=c36e9d16&"
import script from "./Taxis.vue?vue&type=script&lang=js&"
export * from "./Taxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports